import './TokenNomic.scss'
export default function TokenNomic() {
  return (
    <div className="tokenNomicComp">
      <p className="title">We do not have token nor tokenomics yet. But here is the sneak peek if we release one:</p>
      <div className="list">
        <div className="listItem">
          <p className="num">1. </p>
          <div className="content">
            <p><b>Deflationary emission</b></p>
            <p>Emission per block will be declining over period of time</p>
          </div>
        </div>
        <div className="listItem">
          <p className="num">2. </p>
          <div className="content">
            <p><b>Inflation protection system</b></p>
            <p>Incentive reward for liquidity provider and burn unnecessary token from circulation</p>
          </div>
        </div>
        <div className="listItem">
          <p className="num">3. </p>
          <div className="content">
            <p><b>Multi-chains</b></p>
            <p>The token lives in multi-chains ecosystem. It can be bridge from one network to another.</p>
          </div>
        </div>
      </div>
    </div>
  )
}
